import {Button, DatePicker, message, Modal, Popconfirm, Select, Spin, Tooltip} from 'antd'
import React from 'react'
import { CustomRow, CustomCol } from '../../components/Custom';
import { Row,Col,Form, Input } from "antd";
import moment from 'moment';

import {config, post, postFrom, transterQuery} from '../../axios';
import {
     API_CHECKLIST,
    API_device_findList,
    API_salesroom_findList
} from '../../axios/config';
import AuthButton from "../../components/AuthButton/AuthButton";
import {handleExportParams} from "../../utils";
import DetailTitle from "../../components/DetailTitle";
import FileUpload from "../../components/FileUpload";
class DeviceDetail extends React.Component{
  state = {
    id: null,
    visible: false,
    dataInfo: {},
      repairReportId: 0,
    salesroomList: [],
      deviceList:[],
      params:{
          leaseTermTime: null
      },
    dataLoading: false,
    submitLoading: false,
    data: {
        houseLayout: []
    }
  }
  open(id = null) {
    if (id) {
      this.postHouseTypeGet(id)
    }
    this.postDeviceList();
    this.postSalesroomList()
    this.setState({ visible: true, id,params:{leaseTermTime: null} })
    return new Promise((resolve,reject) => {
      this.monitor = { resolve, reject }
    })
  }

  close() {
    this.setState({ visible: false ,data: {}})
    this.props.form.resetFields()
  }
  renderFooter() {
    return (
      <div className="app-modal-footer">
        <Button onClick={this.close.bind(this)}>取消</Button>
      </div>
    )
  }
  postSalesroomList() {
    post({ url: API_salesroom_findList }).then(res =>{
      this.setState({ salesroomList: res })
    })
  }
    postDeviceList() {
        post({ url: API_device_findList }).then(res =>{
            this.setState({ deviceList: res })
        })
    }
  postHouseTypeSubmit(data) {
    const url =  API_CHECKLIST+ '?houseId=' + this.state.id
    this.setState({ submitLoading: true })

    return post({ url, data }).then(res => {
       // this.setState({ submitLoading: false })
    }).finally(err => {
      this.setState({ submitLoading: false })
    })
  }
  postHouseTypeGet(id) {
    this.setState({ dataLoading: true,repairReportId: id });
    this.setState({ dataLoading: false });
  }
  handleSubmit() {
    this.props.form.validateFields((err, values) => {
      if (err) return
      values.id = this.state.id || undefined

      //根据房源Id提交核对清单

      this.postHouseTypeSubmit(values).then(() => {
        this.close()
        this.monitor.resolve()
        message.success('保存成功')
      }).catch((e) => {
        message.error(e.message)
      })
    })
  }
  render(){
    const modalConfig = {
      title: '账单核销',
      visible: this.state.visible,
      footer: this.renderFooter(),
      width: 500,
      onCancel: () => this.close()
    }
  let {
      data,
  } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form
    const labelWidth = 70
    const labelValue = getFieldValue('label')
    return (
      <Modal {...modalConfig}>
        <Spin spinning={this.state.dataLoading}>
          <div className="custom" style={{padding: 20}}>
            <Form  labelCol={{ span: 0 }} wrapperCol={{ span: 24 }}>
              <Row>
                <Col span={24}>
                  <CustomRow >
                    <CustomCol labelStyle={{ width: labelWidth }} label="核销项目">
                        {getFieldDecorator('projectName', {
                            rules: [{
                                required: true, message: '请选择项目',
                            }],
                        })(
                            <DatePicker
                                placeholder={'请选择'}
                                format="YYYY-MM"
                                allowClear={false}
                                onChange={(date) => {
                                     this.setState({ params:{leaseTermTime:  date}  });
                                }}
                            />
                        )}
                    </CustomCol>
                  </CustomRow>
                    <CustomRow divider>
                        <CustomCol labelStyle={{ width: labelWidth }} label="核销月份">
                            {getFieldDecorator('projectName', {
                                rules: [{
                                    required: true, message: '请选择月份',
                                }],
                            })(
                                <DatePicker
                                    placeholder={'请选择'}
                                    disabledDate={this.disabledDate}
                                    format="YYYY-MM"
                                    allowClear={false}
                                    onChange={(date) => {
                                        this.setState({ params:{leaseTermTime:  date}  });
                                    }}
                                />
                            )}
                        </CustomCol>
                    </CustomRow>

                </Col>
              </Row>
            </Form>
          </div>
        </Spin>
      </Modal>
    )

  }
    disabledDate(time) {
        var timeYear = time.get('year');// 年
        var timeMonth = time.get('month');// 年
        var currentYear = moment().year();
        var currentMonth = moment().month();
        if(timeYear<=currentYear){
            if(timeYear>=currentYear){
                if(timeMonth<currentMonth){
                    return false;
                }else{
                    return true;
                }
            }else{
                return false;
            }
        }else{
            return true;
        }
    }

    handleInfo=()=>{
        var leaseTermTime =  this.state.params.leaseTermTime;
        if(leaseTermTime==null){
            alert('请选择月份')
            return false;
        }else{
            const oa = document.createElement('a');
            oa.href = `${config.API_report_deviceRepairReportExprotDateExcel}?${transterQuery(Object.assign({}, handleExportParams() || {}, this.state.params, null))}`;
            oa.setAttribute('target', '_blank');
            document.body.appendChild(oa);
            oa.click()
            return false;
        }

    }

    handleChoose = () => {
        if (this.chooseRef) {
            this.chooseRef.onShow(this.state.repairReportId).then(res => {
                this.postHouseTypeGet(this.state.id);
            }).catch(() => {})
        }
    }

    handleCancel = () => { //关闭页面
        this.props.handleCancel();
        this.setState({ data: {}, loading: false, title: "新增小区/楼栋",leaseTermTime:null });
    }
}



export default Form.create({ wrappedComponentRef: true })(DeviceDetail)


// WEBPACK FOOTER //
// ./src/page/DeviceBill/deviceNewDetail.jsx